/**
 * Second eye photo (duo sets): shows a preview of the chosen image and lets the customer remove it.
 * The input itself joins the buy buttons form through its `form` attribute, so the file is posted
 * with the cart line as properties[Second Eye Photo].
 */
class SecondEyePhoto extends HTMLElement {
  #url = '';

  connectedCallback() {
    this.input = this.querySelector('[data-input]');
    this.preview = this.querySelector('[data-preview]');
    this.dropzone = this.querySelector('[data-dropzone]');
    this.image = this.querySelector('[data-image]');
    this.name = this.querySelector('[data-name]');
    this.input?.addEventListener('change', this.#onChange);
    this.querySelector('[data-remove]')?.addEventListener('click', this.#onRemove);
  }

  disconnectedCallback() {
    this.input?.removeEventListener('change', this.#onChange);
    this.#revoke();
  }

  #onChange = () => {
    const file = this.input.files?.[0];
    if (!file || !file.type.startsWith('image/')) {
      this.#reset();
      return;
    }
    this.#revoke();
    this.#url = URL.createObjectURL(file);
    this.image.src = this.#url;
    this.name.textContent = file.name;
    this.preview.hidden = false;
    this.dropzone.hidden = true;
  };

  #onRemove = () => {
    this.#reset();
    this.input.focus();
  };

  #reset() {
    this.input.value = '';
    this.#revoke();
    this.image.removeAttribute('src');
    this.name.textContent = '';
    this.preview.hidden = true;
    this.dropzone.hidden = false;
  }

  #revoke() {
    if (this.#url) URL.revokeObjectURL(this.#url);
    this.#url = '';
  }
}

if (!customElements.get('second-eye-photo')) customElements.define('second-eye-photo', SecondEyePhoto);
